import { lazy, useCallback } from 'react';

import { useAppTranslation } from 'hooks/use-translates';

import { FormBox } from '@login/components/form-box/form-box';
import { FormHeader } from '@login/components/form-header';

import styles from './friends-family.module.scss';

type FriendsFamilyProps = {
	onChange: (value: boolean) => void;
};

const ButtonsToggler = lazy(
	() => import('@login/components/buttons-toggler/buttons-toggler')
);

export const FriendsFamily = ({ onChange }: FriendsFamilyProps) => {
	const { t } = useAppTranslation();

	const handleChange = useCallback(
		(value: boolean | undefined) => {
			onChange(value ?? false);
		},
		[onChange]
	);

	return (
		<FormBox>
			<FormHeader headerTitle={t('common.friends_and_family_tab')} />

			<div className={styles['content-wrapper']}>
				<p className="body-medium bold">
					{t('friends_and_family.redirect_label')}
				</p>

				<ButtonsToggler
					id="optIn"
					trueLabel={t('register.yes_label')}
					falseLabel={t('register.no_label')}
					value={undefined}
					errorMessage=""
					errorIcon="AlertCircleFilled"
					onChange={(value) => handleChange(value)}
				/>
			</div>
		</FormBox>
	);
};

export default FriendsFamily;
